import React from 'react'
import classnames from 'classnames'

import { Label, SimpleIcon } from 'controls'
import { formatCurrency } from 'services/number'
import { OPERATION_TYPES_BIBLIO as OT, seoTitleWithAddress } from 'services/seo'

import { simpleHeader } from './styles'

const SimpleHeader = ({ className, property }) => {
  const { title, operationType, price } = property

  const label = OT[operationType]

  return (
    <header className={classnames('vip-simple-header', className)}>
      <hgroup>
        <h1 className="title">{seoTitleWithAddress(property)}</h1>

        <span className="titles-container">
          <h2 className="address">{title}</h2>

          <span className="divider">.</span>

          {label && (
            <Label size="small" color="info">
              {label}
            </Label>
          )}

          <span className="divider">.</span>

          <h2 className="price">
            Precio {formatCurrency(price.amount)}{' '}
            <span className="currency">{price.currency}</span>
          </h2>
        </span>
      </hgroup>

      <style jsx>{simpleHeader}</style>
    </header>
  )
}

export default SimpleHeader
